import { render, staticRenderFns } from "./chiSquare.vue?vue&type=template&id=397c6da6&scoped=true"
import script from "./chiSquare.vue?vue&type=script&lang=js"
export * from "./chiSquare.vue?vue&type=script&lang=js"
import style0 from "./chiSquare.vue?vue&type=style&index=0&id=397c6da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397c6da6",
  null
  
)

export default component.exports